<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.$t("menuitems.dns.ptr"),
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],

      ismobile: false,
      activeNames: [],
      activeapp: [],
      loading: true,
      domainlist: [],
    };
  },
  mounted() {
    this.title = this.$t("menuitems.dns.ptr");

    this.items = [
      {
        text: this.$t("menuitems.dns.text"),
        href: "/",
      },

      {
        text: this.$t("menuitems.dns.ptr"),
        active: true,
      },
    ];

    this.userinfo = localStorage.getItem("user");
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    this.getdomainlist();
  },
  methods: {
    getdomainlist() {
      var that = this;
      // 检查是否有 token
      const accessToken = localStorage.getItem('access_token');
      if (!accessToken) {
        that.$message({
          message: '请先登录',
          type: 'warning',
        });
        that.$router.push({ name: 'login' });
        return;
      }
      
      that.$axios
        .get('/getips')
        .then(function (response) {
          if (response.data.status == 200) {
            that.loading = false;
            that.domainlist = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
          // 如果是401错误，adapter.js已经处理了重定向
          if (error.response && error.response.status === 401) {
            // 已经在 adapter.js 中处理了跳转，这里不需要额外操作
          } else {
            that.$message({
              message: '加载IP列表失败',
              type: 'error',
            });
          }
        });
    },
    torecords(domain) {
      this.$router.push({
        path: "/dns/ptr/" + domain,
      });
    },
    /**
     * 日期排序方法
     */
    sortByDate(a, b) {
      const dateA = a.last ? new Date(a.last).getTime() : 0;
      const dateB = b.last ? new Date(b.last).getTime() : 0;
      return dateB - dateA; // 降序排列
    },
    adddomain() {
      var that = this;
      that
        .$prompt(
          that.$t("waring.tips.input.ip"),
          that.$t("waring.tips.text"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
          }
        )
        .then(({ value }) => {
          if (value.length > 0) {
            that.loading = true;
            that.$axios
              .post('/addptr', {
                ip: value,
              })
              .then(function (response) {
                that.loading = false;
                that.getdomainlist();
                if (response.data.status == 200) {
                  
                } else if (response.data.status == 402) {
                  that.$message({
                    message: that.$t("dns.domain.exit"),
                    type: "error",
                  });
                } else if (response.data.status == 300) {
                  that.$message({
                    message: that.$t("dns.domain.format"),
                    type: "error",
                  });
                } else {
                  that.$message({
                    message: that.$t("error.request.500"),
                    type: "error",
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        })
        .catch(() => {});
    },
    deletedomain(domain_id, smscode) {
      var that = this;
      that.$confirm(
        that.$t("waring.tips.deletedomain"),
        that.$t("waring.tips.text"),
        {
          confirmButtonText: that.$t("alter.button.ok"),
          cancelButtonText: that.$t("alter.button.cancel"),
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              that.$axios
                .post('/delete_domain', {
                  id: domain_id,
                  smscode: that.$utils.encryptv2(smscode, that.aeskey),
                })
                .then(function (response) {
                  instance.confirmButtonLoading = false;
                  if (response.data.status == 200) {
                    done();
                    that.$message({
                      message: that.$t("global.tips.alter.delete.success"),
                      type: "success",
                      onClose: () => {
                        that.getdomainlist();
                      },
                    });
                  } else if (response.data.status == 403) {
                    done();
                    that.$message({
                      message: that.$t("global.tips.alter.auth.needauth"),
                      type: "warning",
                      onClose: () => {
                        that
                          .$prompt(
                            that.$t("global.tips.alter.auth.inputsms"),
                            that.$t("global.tips.alter.auth.needauth"),
                            {
                              confirmButtonText: that.$t("alter.button.ok"),
                              cancelButtonText: that.$t("alter.button.cancel"),
                            }
                          )
                          .then(({ value }) => {
                            if (value.length == 6) {
                              that.deletedomain(domain_id, value);
                            } else {
                              that.$message({
                                message: that.$t("global.sms.format"),
                                type: "warning",
                              });
                            }
                          });
                      },
                    });
                  } else if (response.data.status == 408) {
                    that.$message({
                      message: that.$t("global.sms.busy"),
                      type: "warning",
                    });
                  } else if (response.data.status == 405) {
                    that.$message.error(that.$t("error.sms.code"));
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
              done();
            }
          },
        }
      );
    },
    suspend(domain_id,status) {
      var that = this;
      let msg=that.$t("waring.tips.suspend");
      if(status) msg=that.$t("waring.tips.recovery");
      that.$confirm(
        msg,
        that.$t("waring.tips.text"),
        {
          confirmButtonText: that.$t("alter.button.ok"),
          cancelButtonText: that.$t("alter.button.cancel"),
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              that.$axios
                .post('/suspend_domain', {
                  id: domain_id,
                })
                .then(function (response) {
                  instance.confirmButtonLoading = false;
                  done();
                  that.getdomainlist()
                  if (response.data.status == 200) {
                    that.$message({
                      message: that.$t("global.tips.alter.suspend.success"),
                      type: "success",
                    });
                  } else if (response.data.status == 201) {
                    that.$message({
                      message: that.$t("global.tips.alter.recovery.success"),
                      type: "success",
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
              done();
            }
          },
        }
      );
    },
  },
  filters: {
    formatTimer: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" style="min-height: auto;">
            <div style="margin-bottom: 16px;">
              <el-button type="primary" plain @click="adddomain">{{
                $t("dns.ptr.addnew")
              }}</el-button>
            </div>
            <!-- Element UI 表格 -->
            <el-table
              :data="domainlist"
              stripe
              border
              style="width: 100%"
              :fit="true"
              :empty-text="$t('dns.list.no_data') || '暂无数据'"
              tooltip-effect="dark"
              highlight-current-row
              :default-sort="{prop: 'last', order: 'descending'}"
              v-loading="loading"
              element-loading-text="加载中..."
            >
              <!-- IP地址列 -->
              <el-table-column
                :label="$t('dns.list.ip')"
                prop="name"
                min-width="200"
                show-overflow-tooltip
                sortable
              >
                <template slot-scope="scope">
                  <el-link type="primary" @click="torecords(scope.row.id)">
                    {{ scope.row.name }}
                  </el-link>
                </template>
              </el-table-column>
              
              <!-- 记录数量列 -->
              <el-table-column
                :label="$t('dns.list.count')"
                prop="count"
                width="100"
                align="center"
                sortable
              >
              </el-table-column>
              
              <!-- 状态列 -->
              <el-table-column
                :label="$t('dns.list.ipstatus')"
                prop="status"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.enable == 0 && scope.row.status == 0"
                    type="success"
                    size="small"
                    effect="plain"
                  >
                    {{ $t("dns.domain.status.ok") }}
                  </el-tag>
                  <el-tag
                    v-else-if="scope.row.enable == 1 && scope.row.status == 0"
                    type="warning"
                    size="small"
                    effect="plain"
                  >
                    {{ $t("dns.domain.status.supu") }}
                  </el-tag>
                  <el-tag
                    v-else-if="scope.row.enable == 1 && scope.row.status == 1"
                    type="danger"
                    size="small"
                    effect="plain"
                  >
                    {{ $t("dns.domain.status.lock") }}
                  </el-tag>
                  <el-tag
                    v-else-if="scope.row.enable == 1 && scope.row.status == 2"
                    type="info"
                    size="small"
                    effect="plain"
                  >
                    {{ $t("dns.domain.status.disabled") }}
                  </el-tag>
                </template>
              </el-table-column>
              
              <!-- 最后修改时间列 -->
              <el-table-column
                :label="$t('dns.list.lastday')"
                prop="last"
                width="180"
                align="center"
                sortable
                :sort-method="sortByDate"
              >
                <template slot-scope="scope">
                  <span :title="scope.row.last | formatTimer">
                    {{ scope.row.last | formatTimer }}
                  </span>
                </template>
              </el-table-column>
              
              <!-- 操作列 -->
              <el-table-column
                :label="$t('dns.list.action')"
                width="320"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    @click="torecords(scope.row.id)"
                    plain
                  >
                    {{ $t("dns.domain.manguage") }}
                  </el-button>
                  <el-button
                    type="warning"
                    size="small"
                    @click="suspend(scope.row.id, false)"
                    plain
                    v-if="scope.row.enable == 0 && scope.row.status == 0"
                  >
                    {{ $t("dns.domain.status.supu") }}
                  </el-button>
                  <el-button
                    type="info"
                    size="small"
                    @click="suspend(scope.row.id, true)"
                    plain
                    v-if="scope.row.enable == 1 && scope.row.status == 0"
                  >
                    {{ $t("dns.domain.status.recovery") }}
                  </el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="deletedomain(scope.row.id, 0)"
                    plain
                  >
                    {{ $t("dns.domain.delete") }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>